/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiParkingSpotCmsAddToQueueParkingPlaceIdPost } from '../fn/parking-spot/api-parking-spot-cms-add-to-queue-parking-place-id-post';
import { ApiParkingSpotCmsAddToQueueParkingPlaceIdPost$Params } from '../fn/parking-spot/api-parking-spot-cms-add-to-queue-parking-place-id-post';
import { apiParkingSpotCmsGetParkingSpotsPost$Json } from '../fn/parking-spot/api-parking-spot-cms-get-parking-spots-post-json';
import { ApiParkingSpotCmsGetParkingSpotsPost$Json$Params } from '../fn/parking-spot/api-parking-spot-cms-get-parking-spots-post-json';
import { apiParkingSpotCmsGetParkingSpotsPost$Plain } from '../fn/parking-spot/api-parking-spot-cms-get-parking-spots-post-plain';
import { ApiParkingSpotCmsGetParkingSpotsPost$Plain$Params } from '../fn/parking-spot/api-parking-spot-cms-get-parking-spots-post-plain';
import { apiParkingSpotCmsRemoveFromQueueParkingPlaceIdPost } from '../fn/parking-spot/api-parking-spot-cms-remove-from-queue-parking-place-id-post';
import { ApiParkingSpotCmsRemoveFromQueueParkingPlaceIdPost$Params } from '../fn/parking-spot/api-parking-spot-cms-remove-from-queue-parking-place-id-post';
import { apiParkingSpotCmsUpdateDisplayNamePut } from '../fn/parking-spot/api-parking-spot-cms-update-display-name-put';
import { ApiParkingSpotCmsUpdateDisplayNamePut$Params } from '../fn/parking-spot/api-parking-spot-cms-update-display-name-put';
import { apiParkingSpotCmsUpdateParkingSpotsOrderPositionParkingPlaceIdPost } from '../fn/parking-spot/api-parking-spot-cms-update-parking-spots-order-position-parking-place-id-post';
import { ApiParkingSpotCmsUpdateParkingSpotsOrderPositionParkingPlaceIdPost$Params } from '../fn/parking-spot/api-parking-spot-cms-update-parking-spots-order-position-parking-place-id-post';
import { apiParkingSpotUpdateModuleStatusPost } from '../fn/parking-spot/api-parking-spot-update-module-status-post';
import { ApiParkingSpotUpdateModuleStatusPost$Params } from '../fn/parking-spot/api-parking-spot-update-module-status-post';
import { apiParkingSpotUpdateParkingSpotsOrderPositionPost } from '../fn/parking-spot/api-parking-spot-update-parking-spots-order-position-post';
import { ApiParkingSpotUpdateParkingSpotsOrderPositionPost$Params } from '../fn/parking-spot/api-parking-spot-update-parking-spots-order-position-post';
import { GetParkingSpotsResponse } from '../models/get-parking-spots-response';

@Injectable({ providedIn: 'root' })
export class ParkingSpotService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiParkingSpotUpdateModuleStatusPost()` */
  static readonly ApiParkingSpotUpdateModuleStatusPostPath = '/api/ParkingSpot/UpdateModuleStatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiParkingSpotUpdateModuleStatusPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiParkingSpotUpdateModuleStatusPost$Response(params?: ApiParkingSpotUpdateModuleStatusPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiParkingSpotUpdateModuleStatusPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiParkingSpotUpdateModuleStatusPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiParkingSpotUpdateModuleStatusPost(params?: ApiParkingSpotUpdateModuleStatusPost$Params, context?: HttpContext): Observable<void> {
    return this.apiParkingSpotUpdateModuleStatusPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiParkingSpotUpdateParkingSpotsOrderPositionPost()` */
  static readonly ApiParkingSpotUpdateParkingSpotsOrderPositionPostPath = '/api/ParkingSpot/UpdateParkingSpotsOrderPosition';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiParkingSpotUpdateParkingSpotsOrderPositionPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiParkingSpotUpdateParkingSpotsOrderPositionPost$Response(params?: ApiParkingSpotUpdateParkingSpotsOrderPositionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiParkingSpotUpdateParkingSpotsOrderPositionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiParkingSpotUpdateParkingSpotsOrderPositionPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiParkingSpotUpdateParkingSpotsOrderPositionPost(params?: ApiParkingSpotUpdateParkingSpotsOrderPositionPost$Params, context?: HttpContext): Observable<void> {
    return this.apiParkingSpotUpdateParkingSpotsOrderPositionPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiParkingSpotCmsRemoveFromQueueParkingPlaceIdPost()` */
  static readonly ApiParkingSpotCmsRemoveFromQueueParkingPlaceIdPostPath = '/api/ParkingSpot/CmsRemoveFromQueue/{parkingPlaceId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiParkingSpotCmsRemoveFromQueueParkingPlaceIdPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiParkingSpotCmsRemoveFromQueueParkingPlaceIdPost$Response(params: ApiParkingSpotCmsRemoveFromQueueParkingPlaceIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiParkingSpotCmsRemoveFromQueueParkingPlaceIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiParkingSpotCmsRemoveFromQueueParkingPlaceIdPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiParkingSpotCmsRemoveFromQueueParkingPlaceIdPost(params: ApiParkingSpotCmsRemoveFromQueueParkingPlaceIdPost$Params, context?: HttpContext): Observable<void> {
    return this.apiParkingSpotCmsRemoveFromQueueParkingPlaceIdPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiParkingSpotCmsAddToQueueParkingPlaceIdPost()` */
  static readonly ApiParkingSpotCmsAddToQueueParkingPlaceIdPostPath = '/api/ParkingSpot/CmsAddToQueue/{parkingPlaceId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiParkingSpotCmsAddToQueueParkingPlaceIdPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiParkingSpotCmsAddToQueueParkingPlaceIdPost$Response(params: ApiParkingSpotCmsAddToQueueParkingPlaceIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiParkingSpotCmsAddToQueueParkingPlaceIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiParkingSpotCmsAddToQueueParkingPlaceIdPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiParkingSpotCmsAddToQueueParkingPlaceIdPost(params: ApiParkingSpotCmsAddToQueueParkingPlaceIdPost$Params, context?: HttpContext): Observable<void> {
    return this.apiParkingSpotCmsAddToQueueParkingPlaceIdPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiParkingSpotCmsUpdateParkingSpotsOrderPositionParkingPlaceIdPost()` */
  static readonly ApiParkingSpotCmsUpdateParkingSpotsOrderPositionParkingPlaceIdPostPath = '/api/ParkingSpot/CmsUpdateParkingSpotsOrderPosition/{parkingPlaceId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiParkingSpotCmsUpdateParkingSpotsOrderPositionParkingPlaceIdPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiParkingSpotCmsUpdateParkingSpotsOrderPositionParkingPlaceIdPost$Response(params: ApiParkingSpotCmsUpdateParkingSpotsOrderPositionParkingPlaceIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiParkingSpotCmsUpdateParkingSpotsOrderPositionParkingPlaceIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiParkingSpotCmsUpdateParkingSpotsOrderPositionParkingPlaceIdPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiParkingSpotCmsUpdateParkingSpotsOrderPositionParkingPlaceIdPost(params: ApiParkingSpotCmsUpdateParkingSpotsOrderPositionParkingPlaceIdPost$Params, context?: HttpContext): Observable<void> {
    return this.apiParkingSpotCmsUpdateParkingSpotsOrderPositionParkingPlaceIdPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiParkingSpotCmsGetParkingSpotsPost()` */
  static readonly ApiParkingSpotCmsGetParkingSpotsPostPath = '/api/ParkingSpot/CmsGetParkingSpots';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiParkingSpotCmsGetParkingSpotsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiParkingSpotCmsGetParkingSpotsPost$Plain$Response(params?: ApiParkingSpotCmsGetParkingSpotsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetParkingSpotsResponse>> {
    return apiParkingSpotCmsGetParkingSpotsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiParkingSpotCmsGetParkingSpotsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiParkingSpotCmsGetParkingSpotsPost$Plain(params?: ApiParkingSpotCmsGetParkingSpotsPost$Plain$Params, context?: HttpContext): Observable<GetParkingSpotsResponse> {
    return this.apiParkingSpotCmsGetParkingSpotsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetParkingSpotsResponse>): GetParkingSpotsResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiParkingSpotCmsGetParkingSpotsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiParkingSpotCmsGetParkingSpotsPost$Json$Response(params?: ApiParkingSpotCmsGetParkingSpotsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetParkingSpotsResponse>> {
    return apiParkingSpotCmsGetParkingSpotsPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiParkingSpotCmsGetParkingSpotsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiParkingSpotCmsGetParkingSpotsPost$Json(params?: ApiParkingSpotCmsGetParkingSpotsPost$Json$Params, context?: HttpContext): Observable<GetParkingSpotsResponse> {
    return this.apiParkingSpotCmsGetParkingSpotsPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetParkingSpotsResponse>): GetParkingSpotsResponse => r.body)
    );
  }

  /** Path part for operation `apiParkingSpotCmsUpdateDisplayNamePut()` */
  static readonly ApiParkingSpotCmsUpdateDisplayNamePutPath = '/api/ParkingSpot/CmsUpdateDisplayName';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiParkingSpotCmsUpdateDisplayNamePut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiParkingSpotCmsUpdateDisplayNamePut$Response(params?: ApiParkingSpotCmsUpdateDisplayNamePut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiParkingSpotCmsUpdateDisplayNamePut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiParkingSpotCmsUpdateDisplayNamePut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiParkingSpotCmsUpdateDisplayNamePut(params?: ApiParkingSpotCmsUpdateDisplayNamePut$Params, context?: HttpContext): Observable<void> {
    return this.apiParkingSpotCmsUpdateDisplayNamePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
